import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const handleClick = (url: string) => {
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <p className="text-xs font-medium text-accent-600 uppercase tracking-widest mb-2">Browse Categories</p>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-900 leading-tight">
            Find What You Need
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg">
            Explore our curated spreadsheet categories and discover the best finds across every product type
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => handleClick(cat.url)}
              className="group flex flex-col rounded-xl bg-background-50 hover:bg-primary-50 transition-colors cursor-pointer border border-background-200/60 overflow-hidden"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} category - CSSBuy Spreadsheet`}
                  title={`${cat.name} - CSSBuy Sheet Collection`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <div className="flex items-center gap-2 px-3 py-2.5 md:px-3.5 md:py-3">
                <span className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-primary-200 group-hover:text-primary-700 transition-colors flex-shrink-0">
                  <i className={`${cat.icon} text-xs md:text-sm`}></i>
                </span>
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-900 text-left leading-tight">
                  {cat.name}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}